import { render, staticRenderFns } from "./Dashboard1.vue?vue&type=template&id=ea6ebfc8&scoped=true&"
import script from "./Dashboard1.vue?vue&type=script&lang=js&"
export * from "./Dashboard1.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard1.vue?vue&type=style&index=0&id=ea6ebfc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6ebfc8",
  null
  
)

export default component.exports